export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-[72px]">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20digital%20art%20illustration%20with%20warm%20coral%20rose%20and%20soft%20amber%20gold%20gradients%2C%20geometric%20shapes%20floating%20gracefully%2C%20modern%20trendy%20entertainment%20aesthetic%2C%20clean%20minimalist%20composition%2C%20no%20text%2C%20smooth%20elegant%20curves%2C%20editorial%20quality%2C%20high%20detail&width=1600&height=1000&seq=hero-bg-2026&orientation=landscape"
          alt="吃瓜网站主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50" />
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-300/40 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-sm font-medium text-primary-300">全网热点实时追踪</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              吃瓜网站
              <span className="block text-primary-300 md:text-4xl lg:text-5xl mt-2">你的全网八卦视频第一站</span>
            </h1>

            <p className="text-lg md:text-xl text-background-300/90 leading-relaxed mb-8 max-w-2xl lg:max-w-none">
              汇聚最新网红爆料、明星动态、综艺名场面和社交媒体热议事件，每日更新海量吃瓜视频合集。
              从直播翻车到娱乐圈大瓜，从热搜话题到经典回顾，一站式满足你的所有吃瓜需求。
              编辑团队7×24小时紧盯全网动态，让你永远冲在吃瓜最前线。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">15,000+</div>
                <div className="text-sm text-background-400 mt-1">吃瓜视频资源</div>
              </div>
              <div className="w-px h-10 bg-background-300/30" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日更新</div>
                <div className="text-sm text-background-400 mt-1">7×24小时不间断</div>
              </div>
              <div className="w-px h-10 bg-background-300/30" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">500万+</div>
                <div className="text-sm text-background-400 mt-1">月活跃吃瓜用户</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-center"
              >
                立即开始吃瓜
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-background-300/50 text-background-200 font-semibold rounded-lg hover:bg-background-50/10 hover:border-background-200 transition-colors whitespace-nowrap text-center"
              >
                浏览视频合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border-2 border-background-200/20">
              <img
                src="https://readdy.ai/api/search-image?query=A%20bold%20modern%20abstract%20digital%20illustration%20with%20warm%20coral%20rose%20and%20golden%20amber%20tones%2C%20overlapping%20geometric%20shapes%20representing%20social%20media%2C%20entertainment%20videos%2C%20trending%20topics%2C%20vibrant%20dynamic%20composition%2C%20editorial%20quality%2C%20clean%20modern%20design%2C%20no%20text&width=800&height=600&seq=hero-visual-main&orientation=landscape"
                alt="吃瓜网站主视觉 - 热门吃瓜视频合集平台"
                className="w-full h-auto"
              />
              <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                <span className="px-3 py-1 text-xs font-medium bg-background-950/70 text-background-100 rounded-full backdrop-blur-sm">网红爆料</span>
                <span className="px-3 py-1 text-xs font-medium bg-background-950/70 text-background-100 rounded-full backdrop-blur-sm">明星动态</span>
                <span className="px-3 py-1 text-xs font-medium bg-background-950/70 text-background-100 rounded-full backdrop-blur-sm">综艺名场面</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}